import React from "react";

export default function Footer() {
    return (
        <footer className="pt-5" style={{ backgroundColor: "#e7f3ff" }}>

            {/* Newsletter Section */}
            <div className="container position-relative" style={{ marginTop: "-110px" }}>
                <div className="bg-white shadow-lg rounded p-4 p-md-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 mb-3 mb-md-0">
                            <h4 className="fw-semibold mb-1">
                                Stay Updated With <span className="text-primary">Latest Business News</span>
                            </h4>
                            <p className="text-muted small mb-0">
                                Subscribe now and never miss important updates.
                            </p>
                        </div>

                        <div className="col-md-6">
                            <div className="input-group">
                                <input
                                    type="email"
                                    className="form-control rounded-start"
                                    placeholder="Enter your email"
                                />
                                <button className="btn btn-primary px-4 rounded-end">
                                    Subscribe
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Main */}
            <div className="container pt-5 pb-4 mt-4">

                <div className="row">

                    {/* Logo + Info */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <img
                            src="/logo.png"
                            alt="Logo"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "160px", cursor: "pointer" }}
                        />

                        <p className="small text-dark">
                            Dial Nepal helps you discover nearby businesses, services, and
                            professionals with ease. Your trusted local search partner.
                        </p>
                    </div>

                    {/* Categories */}
                    <div className="col-lg-2 col-md-6 mb-4">
                        <h6 className="fw-bold mb-3 text-dark">Categories</h6>
                        <ul className="list-unstyled small text-dark footer-links">
                            <li className="mb-2"><a href="#">IT & Software</a></li>
                            <li className="mb-2"><a href="#">Hotels</a></li>
                            <li className="mb-2"><a href="#">Hospitals</a></li>
                            <li className="mb-2"><a href="#">Education</a></li>
                            <li className="mb-2"><a href="#">Others</a></li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div className="col-lg-2 col-md-6 mb-4">
                        <h6 className="fw-bold mb-3 text-dark">Company</h6>
                        <ul className="list-unstyled small text-dark footer-links">
                            <li className="mb-2"><a href="/">Home</a></li>
                            <li className="mb-2"><a href="/about">About</a></li>

                            <li className="mb-2"><a href="/add-listing">Free Listing</a></li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div className="col-lg-2 col-md-6 mb-4">
                        <h6 className="fw-bold mb-3 text-dark">Support</h6>
                        <ul className="list-unstyled small text-dark footer-links">
                            <li className="mb-2"><a href="#">Our Services</a></li>
                            <li className="mb-2"><a href="#">Help Center</a></li>
                            <li className="mb-2"><a href="#">Contact Us</a></li>
                            <li className="mb-2"><a href="#">Terms & Conditions</a></li>
                            <li className="mb-2"><a href="#">Privacy Policy</a></li>
                        </ul>
                    </div>
                    {/* Contact Info */}
                    <div className="col-lg-2 col-md-6 mb-4">
                        <h6 className="fw-bold mb-3 text-dark">Contact Info</h6>

                        <ul className="list-unstyled small text-dark">
                            <li className="mb-2 d-flex align-items-start">
                                <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                                <span>
                                    Nepalgunj Banke
                                    Bheri, Lumbini Province, Nepal
                                </span>
                            </li>

                            <li className="mb-2 d-flex align-items-center">
                                <i className="bi bi-envelope-fill text-primary me-2"></i>
                                <a href="mailto:info@dialnepal.com" className="text-dark text-decoration-none contact-link">
                                    info@dialnepal.com.np
                                </a>
                            </li>

                            {/* <li className="mb-2 d-flex align-items-center">
                                <i className="bi bi-telephone-fill text-primary me-2"></i>
                                <a href="tel:+9779800000000" className="text-dark text-decoration-none contact-link">
                                    +977-9848427993
                                </a>
                            </li> */}
                        </ul>

                        {/* Social Media */}
                        <div className="d-flex gap-3 mt-3">
                            <a href="https://www.facebook.com/dialnepal777" className="social-icon">
                                <i className="bi bi-facebook"></i>
                            </a>


                            <a href="https://www.youtube.com/@dialnepal" className="social-icon">
                                <i className="bi bi-youtube"></i>
                            </a>
                        </div>
                    </div>


                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-top py-3 text-center small text-dark position-relative">
                © {new Date().getFullYear()} Dial Nepal — All Rights Reserved.

                <a
                    href="#top"
                    className="position-absolute end-0 me-4 fw-semibold back-to-top"
                >
                    Back to top ↑
                </a>
            </div>

            {/* Hover Effects (Internal CSS) */}
            <style>{`
                .footer-links a {
                    text-decoration: none;
                    color: #000;
                    transition: 0.3s ease;
                    cursor: pointer;
                }

                .footer-links a:hover {
                    color: #0d6efd;
                    padding-left: 5px;
                }

                .back-to-top {
                    color: #0d6efd;
                    text-decoration: none;
                    transition: 0.3s ease;
                }

                .back-to-top:hover {
                    color: #084298;
                    font-weight: bold;
                }

                button.btn-primary {
                    transition: 0.3s ease;
                }

                button.btn-primary:hover {
                    background-color: #084298 !important;
                }
            `}</style>

        </footer>
    );
}
